import {
  GET_PRODUCT,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_ERROR,
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_ERROR,
  GET_PRODUCT_LIST_SUCCESS,
} from "./actionTypes"

export const getProduct = data => ({
  type: GET_PRODUCT,
  payload: data,
})

export const getProductSuccess = data => ({
  type: GET_PRODUCT_SUCCESS,
  payload: data,
})

export const getProductError = data => ({
  type: GET_PRODUCT_ERROR,
  payload: data,
})

export const getProductList = data => ({
  type: GET_PRODUCT_LIST,
  payload: data,
})

export const getProductListSuccess = data => ({
  type: GET_PRODUCT_LIST_SUCCESS,
  payload: data,
})

export const getProductListError = data => ({
  type: GET_PRODUCT_LIST_ERROR,
  payload: data,
})
